export var AlarmEventType;
(function (AlarmEventType) {
    AlarmEventType["User"] = "user";
    AlarmEventType["System"] = "system";
    AlarmEventType["Action"] = "action";
    AlarmEventType["Hidden"] = "hidden";
})(AlarmEventType || (AlarmEventType = {}));
